import { EndpointsExperiments } from './EndpointsExperiments';
import { EndpointsPrefilling } from './EndpointsPrefilling';
import { EndpointsSignupClient } from './EndpointsSignupClient';
import { EndpointsSignupCompleted } from './EndpointsSignupCompleted';
import { getFlowEndpointOverrides } from './getFlowEndpointOverrides';
import { EndpointsSignupInterest } from './EndpointsSignupInterest';
import { EndpointsEndOfSignup } from './EndpointsEndOfSignup';
import { EndpointsAuth } from './EndpointsAuth';
import { EndpointsGoogleContactsSync } from './EndpointsGoogleContactsSync';
export const EndpointConfig = Object.assign({}, EndpointsAuth, {}, EndpointsPrefilling, {}, EndpointsSignupClient, {}, EndpointsSignupCompleted, {}, EndpointsEndOfSignup, {}, EndpointsExperiments, {}, getFlowEndpointOverrides(), {}, EndpointsSignupInterest, {}, EndpointsGoogleContactsSync);
export const getEndpoint = endpointKey => EndpointConfig[endpointKey];
export const setEndpointFetched = endpointKey => {
  const endpoint = EndpointConfig[endpointKey];

  if (endpoint) {
    endpoint.fetched = true;
  }
};